import {
  call, put, takeLatest,
} from 'redux-saga/effects';
import { addToTrip } from '../../slices/trip';
import { validateFlightSegmentsRequest, validateFlightSegmentsResponse } from '../../slices/flight';
import axios from '../axiosConfig';

function* validateFlightSegmentsWorker({
  payload: {
    flightItinerary, selectedFareIndex, flightKey, tripId,
  },
}) {
  try {
    const url = '/flights/validate';
    const config = {
      method: 'post',
      url,
      data: { flightItinerary, selectedFareIndex },
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const data = yield call(axios, config);
    const formattedItinerary = data.data;
    if (formattedItinerary) {
      yield put(validateFlightSegmentsResponse({ flightKey, error: undefined }));
      yield put(addToTrip({
        tripId,
        trip: {
          flightItinerary: formattedItinerary,
        },
      }));
    } else {
      yield put(validateFlightSegmentsResponse({ flightKey, error: 'No valid itinerary found. Please select a different flight segment.' }));
    }
  } catch (error) {
    yield put(validateFlightSegmentsResponse({ flightKey, error: 'No valid itinerary found. Please select a different flight segment.' }));
  }
}

function* validateFlightSegmentsWatcher() {
  yield takeLatest(validateFlightSegmentsRequest.toString(), validateFlightSegmentsWorker);
}

export default validateFlightSegmentsWatcher;
